const { h, render, Component } = require('preact');
const SingleActionSSAView = require('../../views/self_service_actions/single_action_ssa')

class DefaultSSA extends Component {
  constructor(props) {
    super(props);
    this.setState({configFromDom: Groupon.Utils.getConfigFromDom()});
  }

  getDefaultSSAs(){
    let defaultSSAs = []
    if (this.state.configFromDom && this.state.configFromDom.defaultServiceActions)
      defaultSSAs = this.state.configFromDom.defaultServiceActions;
    return defaultSSAs;
  }

  constructViewOrderDetailsSSA(SSA){
    return(
      {
        SSAText: I18n.translate(SSA.text),
        UrlForSSA: this.props.orderDetails.orderDetailsUrl
      }
    );
  }

  getSSADetails(SSA){
    switch(SSA.id){
      case 'view_order_details':
        return this.constructViewOrderDetailsSSA(SSA);
    }
    return null;
  }

  constructSSAs(defaultSSAs){
    let constructedSSAs = []
    defaultSSAs.forEach(defaultSSA => {
      let SSADetails = this.getSSADetails(defaultSSA);
      if (SSADetails && SSADetails.SSAText && SSADetails.UrlForSSA)
        constructedSSAs.push(<SingleActionSSAView SSADetails = {SSADetails}/>);
    });
    return constructedSSAs;
  }

  render() {
    let defaultSSAs = this.getDefaultSSAs();
    if (this.props.orderDetails && defaultSSAs.length > 0){
      let constructedSSAs = this.constructSSAs(defaultSSAs);
      if (constructedSSAs.length > 0){
        return (
          <div class="ssa">
            {constructedSSAs}
          </div>
        );
      }

    }
    return null;
  }
}
module.exports = DefaultSSA
